import { LAYOUT_PANEL_COLUMN_BREAKPOINTS } from '../../constants';

// Form column count of the settings panel for the given panel width — the
// panel-width counterpart of the dataset form window media queries.
export const getLayoutPanelFormColumns = (panelWidth: number): number => {
  const breakpoint = LAYOUT_PANEL_COLUMN_BREAKPOINTS.find(
    ({ minWidth }) => panelWidth >= minWidth
  );

  return breakpoint?.columns ?? 12;
};
